import Icon from './Icon';

/**
 * A chapter's resources. The same list serves both repositories — what differs is
 * what the server put in it, which is the point: the filtering is not a client
 * concern, so there is nothing here that decides who sees what.
 */
/** Mirrors ResourceType.Kind, which the server puts on every resource summary. */
const ICONS = { VIDEO: 'play', ACTIVITY: 'activity', DOCUMENT: 'doc' };

export default function ChapterResourceList({ resources, loading, onOpen, emptyMessage }) {
  if (loading) return <div className="empty">Loading…</div>;
  if (!resources || resources.length === 0) {
    return <div className="empty">{emptyMessage ?? 'Nothing in this chapter yet.'}</div>;
  }

  return (
    <div>
      {resources.map((resource) => (
        <button
          type="button"
          className="res-row"
          key={resource.resourceId}
          onClick={() => onOpen(resource)}
        >
          <span className="res-icon" aria-hidden="true">
            {/* Three kinds now, so this reads the kind rather than the one boolean
                that used to be enough. An activity is the thing in a chapter you do
                rather than read, and arriving at it expecting a worksheet is a worse
                surprise than the icon is worth saving. */}
            <Icon name={ICONS[resource.kind] ?? 'doc'} size={17} />
          </span>
          <span className="res-main">
            <b>{resource.name}</b>
            <span className="muted small">
              {resource.typeLabel}
              {resource.durationSeconds ? ` · ${formatDuration(resource.durationSeconds)}` : ''}
              {resource.sizeBytes ? ` · ${formatSize(resource.sizeBytes)}` : ''}
            </span>
          </span>
          {resource.downloadable && <span className="badge">Downloadable</span>}
        </button>
      ))}
    </div>
  );
}

function formatSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function formatDuration(seconds) {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
}
